export const PatientTypes = [
    { label: "OPD ( Outpatient Department )", value: "opd" },
    { label: "OT ( Operation Theatre )", value: "ot" },
    { label: "ICU ( Intensive Care Unit )", value: "icu" },
    { label: "NICU ( Neonatal Intensive Care Unit )", value: "nicu" },
];

export const WardTypes = [
    {label:"General", value:"general"},
    {label:"Private", value:"private"},
    {label:"Semi Private", value:"semi-private"}
]
export const GenderTypes = [
    {label:"Male", value:"male"},
    {label:"Female", value:"female"},
    {label:"Child", value:"child"},
    {label:"Others", value:"others"}
]

export const BloodGroups = [
  { label: "A+", value: "A+" },
  { label: "A-", value: "A-" },
  { label: "B+", value: "B+" },
  { label: "B-", value: "B-" },
  { label: "AB+", value: "AB+" },
  { label: "AB-", value: "AB-" },
  { label: "O+", value: "O+" },
  { label: "O-", value: "O-" },
];